
<div v-if="context.incident">
    <div class="v-flex">
        <!-- add unit selection -->
        <div class="add-unit-selection">
            <v-menu
                v-model="showSelection"
                :close-on-content-click = "false"
                offset-y
            >
                <template v-slot:activator="{ on, attrs }">
                    <div
                        v-bind = "attrs"
                        v-on   = "on"
                    >
                        <v-icon class="toolbar-button-ripple" size="22" color="white">mdi-plus</v-icon>
                    </div>
                </template>

                <c-site-selection
                    :customer        = "customer"
                    :force-all-units = "isModernization"
                    @cut             = "onAdd"
                />
            </v-menu>
        </div>
        <!-- add unit selection -->

        <!-- prev site button -->
        <div v-if="sites && sites.length > 1" style="margin-top: -2px;" class="mr-1">
            <c-toolbar-button
                :icon="index === 0 ? 'mdi-arrow-left-drop-circle-outline' : 'mdi-arrow-left-drop-circle'"
                color="white"
                size="24"
                tooltip="Vorheige Anlage"
                @click = "onPrev"
            />
        </div>
        <!-- prev site button -->

        <p-inc-navigation-menu
            :step-units = "stepUnits"
            :step       = "step"
            @select     = "onSelect"
            @remove     = "onRemove"
        />

        <!-- next site button -->
        <div v-if="sites && sites.length > 1" style="margin-top: -2px;" class="ml-0">
            <c-toolbar-button
                :icon="index >= stepUnits.length-1 ? 'mdi-arrow-right-drop-circle-outline' : 'mdi-arrow-right-drop-circle'"
                color="white"
                size="24"
                tooltip="Nächste Anlage"
                @click = "onNext"
            />
        </div>
        <!-- next site button -->
    </div>
</div>
